import { render, staticRenderFns } from "./txtPreview.vue?vue&type=template&id=65af3bc3&scoped=true&"
import script from "./txtPreview.vue?vue&type=script&lang=js&"
export * from "./txtPreview.vue?vue&type=script&lang=js&"
import style0 from "./txtPreview.vue?vue&type=style&index=0&id=65af3bc3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65af3bc3",
  null
  
)

export default component.exports